/**
 * The slightly refactored version of "EAssessment.UI.Common/app-common/utils/url.js"
 * TODO: Please, continue to refactor this
 */

import { getConfig } from "@cirrus/config"
import { config as imgProcConfig } from "@cirrus/legacy/app-common/images/img-proc-config.js"

import { Str } from "@cirrus/fe-lib"

import { concat } from "ramda"
import { flow } from "fp-ts/es6/function"

// TODO: Create a common version from `withMain` and `withRoot` functions

export const withMain = (relativeUrl, baseUrl) => {
  if (!relativeUrl && !baseUrl) return ""
  if (relativeUrl.indexOf("~") > -1) relativeUrl = relativeUrl.replace("~", "")

  const base = window.location.protocol + "//" + window.location.host

  return base.concat(baseUrl || getConfig().BaseUrl, relativeUrl)
}

export const withRoot = (relativeUrl) => {
  if (!relativeUrl) return ""
  if (relativeUrl.indexOf("~") > -1) relativeUrl = relativeUrl.replace("~", "")

  const base = getConfig().ApiHost

  return base.concat(relativeUrl)
}

export const withAuthor = (relativeUrl) => {
  if (!relativeUrl) return ""
  if (relativeUrl.indexOf("~") > -1) relativeUrl = relativeUrl.replace("~", "")

  const base = window.location.protocol + "//" + window.location.host

  return base.concat("/", relativeUrl)
}

export const withRealtime = (relativeUrl) => {
  if (!relativeUrl) return ""
  if (relativeUrl.indexOf("~") > -1) relativeUrl = relativeUrl.replace("~", "")

  const base = getConfig().SignalrHost

  return base.concat(relativeUrl)
}

export const withDelivery = (relativeUrl) => {
  if (App.isPreview) {
    return withRoot("/api/v1/delivery/preview" + relativeUrl)
  } else if (App.isAnonymous) {
    return withRoot("/api/v1/delivery/anonymous" + relativeUrl)
  } else {
    return withRoot("/api/v1/delivery" + relativeUrl)
  }
}

export const withProctoring = (relativeUrl) => withRoot("/api/v1/proctoring" + relativeUrl)

export const withSaml = (relativeUrl) => {
  if (!relativeUrl) return ""
  if (relativeUrl.indexOf("~") > -1) relativeUrl = relativeUrl.replace("~", "")

  const base = getConfig().SamlApiHost

  return base.concat(relativeUrl)
}

export const withToken = (relativeUrl, options) => {
  // because file download by link, need set access_token in url
  let template = "{url}"
  const params = options || {}

  params["access_token"] = sessionStorage.getItem(getConfig().TokenKey)
  template += "?{opts}".replace("{opts}", $.param(params))

  return template.replace("{url}", withRoot(relativeUrl))
}

export const withImageResizer = function (url, options) {
  // parse options, exs: { w: 100, h: 100 }, '?w=100&h=100', 'introAvatar'. last from imgProcConfig
  if (!url) return url

  let parsedOptions = ""

  if (typeof options == "string") {
    if (options.indexOf("?") == 0) parsedOptions = options
    else if (imgProcConfig[options]) parsedOptions = $.param(imgProcConfig[options])
  } else if (options) {
    parsedOptions = $.param(options)
  }

  let template = "{url}"

  if (parsedOptions) {
    template += "?{opts}".replace("{opts}", parsedOptions)
  }

  return template.replace("{url}", url)
} // TODO: this is work around for exam results, this logic must to be in server

export const withAnonymousSharing = (token) =>
  withAuthor(concat("delivery/anonymous-login?session=", token))
